/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CelebrationFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M37.4702 16.8796C38.4402 16.8796 39.2302 16.0896 39.2302 15.1096C39.2302 14.1296 38.4402 13.3496 37.4702 13.3496C36.5002 13.3496 35.7002 14.1396 35.7002 15.1096C35.7002 16.0796 36.4902 16.8796 37.4702 16.8796Z"
      fill="#000"
    />
    <path
      d="M28.8996 8.30953C29.8796 8.30953 30.6696 7.50953 30.6696 6.53953C30.6696 5.56953 29.8796 4.76953 28.8996 4.76953C27.9196 4.76953 27.1396 5.56953 27.1396 6.53953C27.1396 7.50953 27.9296 8.30953 28.8996 8.30953Z"
      fill="#000"
    />
    <path
      d="M11.7398 35.2899L10.3398 29.7999C10.2398 29.3999 9.90981 29.1299 9.49981 29.1099C9.07981 29.0799 8.73981 29.3199 8.58981 29.7099L6.33981 35.7699C6.14981 36.2699 6.26981 36.8199 6.64981 37.1999C6.90981 37.4599 7.24981 37.5999 7.59981 37.5999C7.75981 37.5999 7.91981 37.5699 8.07981 37.5099L11.1598 36.3699C11.5998 36.2099 11.8398 35.7399 11.7298 35.2899H11.7398Z"
      fill="#000"
    />
    <path
      d="M21.8002 24.6597C21.5102 24.3697 21.0702 24.3097 20.7102 24.5097C20.3502 24.7097 20.1702 25.1097 20.2602 25.5097L21.5702 31.4097C21.6302 31.6697 21.7902 31.8897 22.0302 32.0197C22.1702 32.0897 22.3202 32.1297 22.4702 32.1297C22.5802 32.1297 22.6902 32.1097 22.7902 32.0697L24.8302 31.3097C25.4102 31.0897 25.8302 30.5997 25.9702 29.9997C26.1002 29.3897 25.9202 28.7697 25.4802 28.3297L21.8102 24.6597H21.8002Z"
      fill="#000"
    />
    <path
      d="M16.0799 19.1403C16.0799 19.1403 16.0099 19.0003 15.9799 18.9603C15.5199 18.3703 14.7899 18.0903 14.0399 18.2003C13.2799 18.3203 12.6299 18.8403 12.3699 19.5603L11.7199 21.3103C11.4199 22.1203 11.3699 22.9903 11.5899 23.8203L14.2299 34.1503C14.2899 34.4003 14.4599 34.6103 14.6899 34.7303C14.8199 34.8003 14.9699 34.8303 15.1099 34.8303C15.2199 34.8303 15.3299 34.8103 15.4299 34.7703L18.4999 33.6303C18.9299 33.4703 19.1699 33.0203 19.0799 32.5703L16.0799 19.1203V19.1403Z"
      fill="#000"
    />
    <path
      d="M23.9002 20.1002C24.2002 20.4002 24.5902 20.5502 24.9802 20.5502C25.3702 20.5502 25.7602 20.4002 26.0602 20.1002L33.8102 12.3502C34.4102 11.7502 34.4102 10.7902 33.8102 10.1902C33.2102 9.59023 32.2502 9.59023 31.6502 10.1902L23.9002 17.9402C23.3002 18.5402 23.3002 19.5002 23.9002 20.1002Z"
      fill="#000"
    />
    <path
      d="M20.8402 13.9903L23.7902 6.06027C24.0802 5.27027 23.6801 4.39027 22.8901 4.10027C22.1001 3.81027 21.2202 4.21027 20.9302 5.00027L17.9801 12.9303C17.6901 13.7203 18.0901 14.6003 18.8801 14.8903C19.0601 14.9603 19.2301 14.9903 19.4101 14.9903C20.0301 14.9903 20.6102 14.6103 20.8402 14.0003V13.9903Z"
      fill="#000"
    />
    <path
      d="M39.9098 21.1204C39.6198 20.3304 38.7398 19.9304 37.9498 20.2204L30.0198 23.1704C29.2298 23.4604 28.8298 24.3404 29.1198 25.1304C29.3498 25.7404 29.9298 26.1204 30.5498 26.1204C30.7298 26.1204 30.9098 26.0904 31.0798 26.0204L39.0098 23.0704C39.7998 22.7804 40.1998 21.9004 39.9098 21.1104V21.1204Z"
      fill="#000"
    />
    <path
      d="M34.8696 30.6504C33.8896 30.6504 33.0996 31.4504 33.0996 32.4204C33.0996 33.3904 33.8896 34.1804 34.8696 34.1804C35.8496 34.1804 36.6296 33.3904 36.6296 32.4204C36.6296 31.4504 35.8396 30.6504 34.8696 30.6504Z"
      fill="#000"
    />
    <path
      d="M11.9397 11.2605C12.9197 11.2605 13.7097 10.4605 13.7097 9.49047C13.7097 8.52047 12.9197 7.73047 11.9397 7.73047C10.9597 7.73047 10.1797 8.52047 10.1797 9.49047C10.1797 10.4605 10.9697 11.2605 11.9397 11.2605Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default CelebrationFill
